import 'rxjs'
import {ajax} from 'rxjs/observable/dom/ajax'
import config from '../config'
import errorHandlerBuilder from './errorHandlerBuilder'
import {
  ACTION_UPDATE_CURRENT_USER_INFO_ERROR,
  ACTION_UPDATE_CURRENT_USER_INFO_LOADING,
  ACTION_UPDATE_CURRENT_USER_INFO_LOADED,
  PATH_UPDATE_USER_INFO
} from '../constants'

const api_server_host = config.api_server_host

const errorHandler = errorHandlerBuilder(ACTION_UPDATE_CURRENT_USER_INFO_ERROR)

const epic = (action$, store) =>
  action$.ofType(ACTION_UPDATE_CURRENT_USER_INFO_LOADING)
    .mergeMap(action => {

      const tokenData = store.getState().user
      const token = tokenData.access_token
      const type = tokenData.token_type

      return ajax({
        method: 'POST',
        url: `${api_server_host}${PATH_UPDATE_USER_INFO}`,
        headers: {
          Authorization: `${type} ${token}`,
          'Content-Type': 'application/json'
        },
        body: action.payload,
        responseType: 'json'
      }).map(data=> {
        const userInfo = data.response
        const {name, profileImagePath, dob, emailAddress, country, city, education, occupation, isMale} = userInfo
        return {
          type: ACTION_UPDATE_CURRENT_USER_INFO_LOADED, payload: {
            name,
            profileImagePath,
            dob,
            emailAddress,
            country,
            city,
            education,
            occupation,
            isMale
          }
        }
      }).catch(errorHandler)

    })
export default epic




// WEBPACK FOOTER //
// ./src/epics/UpdateCurrentUserInfoEpic.js